import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EMPTY, Subscription, catchError, switchMap, timer } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FUSE_SKIP_LOADING } from '@fuse/services/loading/loading-context.token';

interface AppVersion {
  version: string;
  buildId: string;
  buildTime: string;
  commit: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {

  private readonly _httpClient = inject(HttpClient);
  private readonly _toastr = inject(ToastrService);

  private readonly _pollIntervalMs = 5 * 60 * 1000;
  private readonly _versionUrl = './version.json';

  private _currentBuildId = '';
  private _updateToastShown = false;
  private _subscription: Subscription | null = null;

  start(): void {
    if (this._subscription) {
      return;
    }

    this._subscription = timer(0, this._pollIntervalMs)
      .pipe(
        switchMap(() => this._loadVersion().pipe(
          catchError(() => EMPTY)
        ))
      )
      .subscribe(version => this._handleVersion(version));
  }

  private _loadVersion() {
    const context = new HttpContext().set(FUSE_SKIP_LOADING, true);
    const cacheBuster = Date.now();

    return this._httpClient.get<AppVersion>(`${this._versionUrl}?v=${cacheBuster}`, { context });
  }

  private _handleVersion(version: AppVersion): void {
    if (!version?.buildId) {
      return;
    }

    if (!this._currentBuildId) {
      this._currentBuildId = version.buildId;
      return;
    }

    if (this._currentBuildId === version.buildId || this._updateToastShown) {
      return;
    }

    this._updateToastShown = true;

    const toast = this._toastr.info(
      'ระบบมีเวอร์ชันใหม่ คลิกที่นี่เพื่อรีเฟรช',
      'มีอัปเดตใหม่',
      {
        closeButton: true,
        disableTimeOut: true,
        tapToDismiss: false,
      }
    );

    toast.onTap.subscribe(() => {
      window.location.reload();
    });
  }

}
